/**
 * Fixed analytics taxonomy — shared by the client tracker, the zod schemas and
 * the ingest endpoint. Keep in sync with docs/analytics-events.md.
 */

/** Allowed event names — the complete taxonomy. */
export const EVENT_NAMES = [
  "cta_click",
  "cta_focus",
  "deep_link_focus",
  "deep_link_error",
  "element_view",
  "form_start",
  "form_submit",
  "form_success",
  "form_error",
] as const;
export type EventName = (typeof EVENT_NAMES)[number];

/** What kind of CTA was clicked. */
export const CTA_TYPES = [
  "primary_button",
  "secondary_button",
  "inline_link",
  "nav_link",
  "footer_link",
  "email_link",
  "external_link",
  "download",
  "booking_widget",
] as const;
export type CtaType = (typeof CTA_TYPES)[number];

/** Lifecycle status of a form interaction. */
export const FORM_STATUSES = ["started", "submitted", "success", "error", "invalid"] as const;
export type FormStatus = (typeof FORM_STATUSES)[number];

/** UTM parameters we accept — nothing else is read from the query string. */
export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;
export type UtmKey = (typeof UTM_KEYS)[number];
export type Utm = Partial<Record<UtmKey, string>>;
